<template>
    <div class="default-page">

        <div class="buttons">
            <button class="button btn-primary" @click="saveForm">
                {{ $ml.get('buttons.save') }}
            </button>

            <button class="button btn-primary"
                    @click="goToList">
                {{ $ml.get('buttons.back') }}
            </button>

            <button class="button btn-danger"
                    v-if="this.element && this.element.id && getPermissionSection('delete')"
                    @click="openConfirmDelete = true">
                {{ $ml.get('buttons.delete') }}
            </button>

            <button v-for="(button, index) in buttons"
                    :class="['button', button.class]"
                    @click="button.function">
                {{ button.label }}
            </button>
        </div>

        <div class="block" :key="change">
            <div class="title">{{ pageTitle }}</div>
            <div class="body flex-row-wrap">
                <div :class="getClass(label)"
                     v-for="(label, key) in labels">
                    <div class="formBlock">
                        <p :class="['label', {'required' : form_required.includes(label)}]">
                            {{ form_labels[label] }}
                            <template v-if="form_required.includes(label)">*</template>
                        </p>
                        <template v-if="getTypeForm(label) === 'number'">
                            <input type="number"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'boolean'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    v-model="element[label]"
                                    :options="selectBooleanOptions"
                                    :placeholder="form_labels[label]">
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'string'">
                            <div class="input disabled" v-if="element[label]">{{ element[label] }}</div>
                        </template>
                        <template v-if="getTypeForm(label) === 'date'">
                            <date-picker
                                valueType="format"
                                format="MM.DD.YYYY"
                                v-model="element[label]"
                                :placeholder="form_labels[label]"
                            />
                        </template>
                        <template v-if="getTypeForm(label) === 'link'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'textarea'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'input'">
                            <input type="text"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'select'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    :label="getSelectLabel(label)"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'select-tags'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    :multiple="true"
                                    :taggable="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="w50">
                    <div class="formBlock">
                        <p class="label">{{ lang.form.tags }}</p>
                        <div class="defaultMultiselect" v-if="dictionaries.tags">
                            <Multiselect
                                track-by="id"
                                label="title"
                                :multiple="true"
                                :taggable="true"
                                :close-on-select="false"
                                :clear-on-select="false"
                                :preserve-search="true"
                                v-model="tags"
                                :options="dictionaries.tags"
                                :placeholder="lang.form.tags">
                                <template slot="noResult">
                                    {{ $ml.get('interface.no_result') }}
                                </template>
                                <template slot="noOptions">
                                    {{ $ml.get('interface.no_options') }}
                                </template>
                            </Multiselect>
                        </div>
                    </div>
                </div>
                <div class="w50">
                    <div class="formBlock">
                        <p class="label">{{ lang.form.types }}</p>
                        <div class="defaultMultiselect" v-if="dictionaries.types">
                            <Multiselect
                                track-by="id"
                                label="title"
                                :multiple="true"
                                :taggable="true"
                                :close-on-select="false"
                                :clear-on-select="false"
                                :preserve-search="true"
                                v-model="types"
                                :options="dictionaries.types"
                                :placeholder="lang.form.types">
                                <template slot="noResult">
                                    {{ $ml.get('interface.no_result') }}
                                </template>
                                <template slot="noOptions">
                                    {{ $ml.get('interface.no_options') }}
                                </template>
                            </Multiselect>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="title">{{ lang.labels.in_the_future }}</div>
            <div class="body">
                <p v-if="!in_the_future">No data</p>
                <template v-else>

                    <template v-if="in_the_future.in_the_future === 'keep'">
                        <p><b>Method</b>: Keep in the family</p>
                    </template>

                    <template v-if="in_the_future.in_the_future === 'bequeathed'">
                        <p><b>Method</b>: Bequeathed</p>
                        <p><br></p>

                        <p><b>Recipient</b>:</p>
                        <p><b>First name</b>: {{ in_the_future.bequeathed_first_name }}</p>
                        <p><b>Last name</b>: {{ in_the_future.bequeathed_last_name }}</p>
                        <p><b>Relationship</b>: {{ in_the_future.bequeathed_relationship }}</p>
                        <p><b>Email</b>: {{ in_the_future.bequeathed_email }}</p>
                    </template>

                    <template v-if="in_the_future.in_the_future === 'charitable'">
                        <p><b>Method</b>: Charitable donation</p>
                        <p><br></p>

                        <p><b>Organization</b>:</p>
                        <p><b>Name of organization</b>: {{ in_the_future.charitable_name }}</p>
                        <p><b>Contact email or URL</b>: {{ in_the_future.charitable_contact }}</p>
                    </template>

                    <template v-if="in_the_future.in_the_future === 'sell'">
                        <p><b>Method</b>: Sell </p>
                        <p><br></p>

                        <p><b>Set an email reminder?</b></p>
                        <p><b>Remind me in</b>: {{ in_the_future.notify_in }}</p>
                        <p><b>Custom date</b>: {{ in_the_future.notify_date }}</p>
                        <p><b>Notification date</b>: {{ in_the_future.notification_send_at }}</p>
                    </template>

                    <template v-if="in_the_future.in_the_future === 'late'">
                        <p><b>Method</b>: Too late!</p>
                    </template>

                    <template v-if="in_the_future.in_the_future === 'wish'">
                        <p><b>Method</b>: As you wish</p>
                    </template>
                </template>
            </div>
        </div>

        <div class="block">
            <div class="title">{{ lang.labels.images }}</div>
            <div class="body">
                <div class="drag-in-drop"
                     @dragover="dragoverFile"
                     @dragleave="dragleaveFile"
                     @drop="(e) => dropFile(e, 'images')"
                     @click="$refs.image.click()">
                    <input type="file"
                           @change="onChangeFile('images')"
                           ref="image"
                           multiple
                           :accept="acceptImages" />
                    <div class="label">{{ lang.labels.drag_in_drop }}</div>
                </div>
                <draggable v-model="images"
                           class="images"
                           :forceFallback="true">
                    <div class="image"
                         v-for="(image,index) in images"
                         :key="index"
                         :style="{'background-image': `url(${ getMediaUrl(image) })` }">

                        <template v-if="image.type === 'video'">
                            <img class="icon-preview" src="/assets/img/placeholders/video-mini.svg" alt="">
                        </template>

                        <template v-if="image.type === 'audio'">
                            <p class="icon-preview">
                                <img src="/assets/img/placeholders/audio-mini.svg" alt="">
                                <span>{{ image.filename }}</span>
                            </p>
                        </template>

                        <div class="main" @click="setMainImage(index)"></div>
                        <div class="delete" @click="deleteImage(index)">
                            <span class="ico-i icon-delete"></span>
                        </div>
                        <div class="selected" v-if="image.is_main">
                            <span class="ico-i icon-approved"></span>
                        </div>
                    </div>
                </draggable>
                <div class="images">

                </div>
            </div>
        </div>
        <div class="block">
            <div class="title">{{ lang.labels.documents }}</div>
            <div class="body">
                <div class="drag-in-drop"
                     @dragover="dragoverFile"
                     @dragleave="dragleaveFile"
                     @drop="(e) => dropFile(e, 'documents')"
                     @click="$refs.document.click()">
                    <input type="file"
                           @change="onChangeFile('documents')"
                           ref="document"
                           multiple
                           :accept="acceptDocuments" />
                    <div class="label">{{ lang.labels.drag_in_drop }}</div>
                </div>
                <div class="documents">
                    <div class="table-scroll__wrapper">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="w50">{{ lang.labels.document }}</th>
                                <th class="w40">{{ lang.labels.document_type }}</th>
                                <th class="w10">#</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(document,index) in documents"
                                :key="index">
                                <td>
                                    <template v-if="document.url">
                                        <a class="link"
                                           :href="document.url"
                                           target="_blank">
                                            {{ document.title }}
                                        </a>
                                    </template>
                                    <template v-else>
                                        {{ document.title }}
                                    </template>
                                </td>
                                <td class="text-l">
                                    <div class="defaultMultiselect">
                                        <Multiselect
                                            track-by="id"
                                            label="title"
                                            v-model="document.type"
                                            :options="dictionaries.document_types"
                                            :placeholder="lang.labels.document_type">
                                            <template slot="noResult">
                                                {{ $ml.get('interface.no_result') }}
                                            </template>
                                            <template slot="noOptions">
                                                {{ $ml.get('interface.no_options') }}
                                            </template>
                                        </Multiselect>
                                    </div>
                                </td>
                                <td>
                                    <button class="button btn-danger" @click="deleteDocument(index)">
                                        <span class="icon ico-i icon-delete"></span>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>


        <ModalWindow :open="openConfirmDelete"
                     @closeModal="openConfirmDelete = false">
            <template slot="title">
                {{ $ml.get('interface.confirm_action') }}
            </template>
            <template slot="body">
                {{ $ml.get('interface.confirm_action_delete') }}
            </template>
            <template slot="buttons">
                <button class="button btn-danger" @click="deleteForm">
                    {{ $ml.get('buttons.delete') }}
                </button>
            </template>
        </ModalWindow>

    </div>
</template>

<script>
import FormMethodsDefault from "../Utils/Page/Form/FormMethodsDefault";
import heic2any from "../../../../scripts/heic2any";
import draggable from "vuedraggable";

export default {
    name: "Form",
    components: {
        draggable
    },
    mixins: [FormMethodsDefault],
    data() {
        return {
            acceptImages: '.jpg,.jpeg,.png,.svg,.gif,.heic,.avi,.mov,.mp4,.ogg,.wmv,.webm,.mkv,.mp3,.ac3,.wav,.aac,.m4v,.m4a,.wma',
            acceptDocuments: '.doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png,.svg,.gif,.heic,.avi,.mov,.mp4,.ogg,.wmv,.webm,.mkv,.mp3,.ac3,.wav,.aac,.m4v,.m4a,.wma',

            lang: this.$ml.get('pages.artifact'),
            buttons: [],

            typeForm: {
                user_id: 'select',
                countries: 'select-tags',
                origin_type_id: 'select',
                origin_century_id: 'select',
                occasion_id: 'select',
                when_acquired: 'date',
                value_id: 'select',
                size_unit_id: 'select',
                weight_unit_id: 'select',
                is_published: 'boolean',
                is_inspiration: 'boolean',
                body: 'textarea',
                visible: 'boolean',
                is_main: 'boolean',
                is_main_position: 'number',
            },

            selectKeys: ['select', 'custom-select', 'boolean'],

            form_required: [
                'title',
                'body'
            ],

            pageRouteList: 'artifact',
            pageRouteEdit: 'artifact.edit',
            pageApi: 'artifact',
            pagePermission: 'artifact.items',

            images: [],
            documents: [],
            tags: [],
            types: [],
            in_the_future: null,
        }
    },
    computed: {
        isVisibleMedia() {
            if (this.element.is_published) {
                return this.element.is_published.id
            }
            return false
        },
    },
    methods: {
        getMediaUrl(media) {
            if (!this.isVisibleMedia) {
                return '/images/no_image.png'
            }

            return media.preview_url_cdn_query ?? media.url_preview ?? media.url
            //media.type === 'video' && media.url_preview ? media.url_preview : media.url
        },
        saveForm() {
            let access = false
            if (this.id) {
                access = this.getPermissionSection('edit')
            } else {
                access = this.getPermissionSection('create')
            }
            if (!access) {
                this.$store.commit('setNotification', {
                    type: 'error',
                    message: 'Permission denied'
                })
                return;
            }

            let data = {
                element: {},
                images: this.images,
                documents: this.documents,
            }

            for (let key in this.element) {
                if (this.form_required.includes(key) && !this.element[key]) {
                    this.$store.commit('setNotification', {
                        type: 'error',
                        message: this.$ml.get('interface.empty_field') + ' - ' + this.lang.form[key]
                    })
                    return
                }

                data.element[key] = this.element[key]
                if (this.selectKeys.includes(this.getTypeForm(key))) {
                    this.getValueSelect(data.element, key)
                }
                if (this.getTypeForm(key) === 'boolean') {
                    if (this.element[key]) {
                        data.element[key] = this.element[key].id
                    }
                }
            }


            let form = new FormData()
            this.images.map(item => {
                if (item.is_upload) {
                    if (item.type === 'image' && item.heic) {
                        form.append(item.id + '_heic', item.file)
                        item.file = item.jpeg
                    }
                    if (item.type === 'video') {
                        form.append(item.id + '_thumbnail', item.thumbnail)
                    }
                    form.append(item.id, item.file)
                    delete item.url
                }
                return item
            })
            this.documents.map(item => {
                if (item.is_upload) {
                    form.append(item.id, item.file)
                    item.type_id = item.type ? item.type.id : null
                }
                return item
            })


            form.append('images', JSON.stringify(data.images))
            form.append('documents', JSON.stringify(data.documents))
            form.append('tags', JSON.stringify(this.tags))
            form.append('types', JSON.stringify(this.types))
            form.append('element', JSON.stringify(data.element))


            this.$store.commit('setLoading', true)
            axios.post(this.$store.getters.getApiUrl(this.pageApi), form)
                .then(({data}) => {
                    if (data.success) {
                        if (!this.id) {
                            this.id = data.element.id
                            this.$router.push({name: this.pageRouteEdit, params: {id: data.element.id}})
                        }
                        this.getData()
                        this.$store.commit('setNotification', {
                            type: 'success',
                            message: this.$ml.get('interface.saved')
                        })
                    } else {
                        this.$store.commit('setErrorMessage', data.message)
                    }
                })
                .finally(() => {
                    this.$store.commit('setLoading', false)
                })
        },
        deleteDocument(index) {
            this.documents.splice(index, 1)
        },
        deleteImage(index) {
            this.images.splice(index, 1)
        },
        setMainImage(index) {
            this.images.map(item => {
                item.is_main = false
            })
            this.images[index].is_main = true
        },
        setExtraData(data) {
            this.images = Array.from(data.element.images)
            this.documents = Array.from(data.element.documents)
            this.types = Array.from(data.element.types)
            this.tags = Array.from(data.element.tags)
            this.in_the_future = data.element.in_the_future
        },

        // Событие при перетаскивании файла
        dragoverFile(event) {
            event.preventDefault();
            event.currentTarget.classList.add('over');
        },
        // Событие при убирании курсора при перетаскивании
        dragleaveFile(event) {
            event.currentTarget.classList.remove('over');
        },
        // Событие добавления файла
        dropFile(event, type) {

            // Снимаем стиль
            event.currentTarget.classList.remove('over')
            event.preventDefault()

            // Помещаем изображение в input
            if (type === 'images') {
                this.$refs.image.files = event.dataTransfer.files
            } else if (type === 'documents') {
                this.$refs.document.files = event.dataTransfer.files
            }

            // Вызываем событие изменения
            this.onChangeFile(type)
        },
        // Изменение при добавлении файла
        onChangeFile(type) {
            let files = []
            if (type === 'images') {
                files = this.$refs.image.files
            } else if (type === 'documents') {
                files = this.$refs.document.files
            }
            files = Array.from(files)
            files.map(file => {
                if (!this.acceptFile(file, type)) {
                    this.$store.commit('setNotification', {
                        type: 'error',
                        message: this.lang.labels.file_error.replace( /{f}/, file.name)
                    })
                } else {
                    let key = 'upload_' + Math.abs(Math.ceil(Math.random() * (1000 - 9999) + 1000))
                    if (type === 'images') {
                        let mediaType = 'image'
                        if (/^video\/*/.test(file.type)) mediaType = 'video'
                        if (/^audio\/*/.test(file.type)) mediaType = 'audio'

                        let item = {
                            id: key,
                            filename: file.name,
                            type: mediaType,
                            url: '',
                            error: null,
                            file: file,
                            heic: false,
                            jpeg: null,
                            is_upload: true,
                            is_main: false,
                        }

                        if (mediaType === 'image') {
                            if (file.name.toLowerCase().match(".heic$") || file.type.match("image/heic")) {
                                item.heic = true
                                item.type = 'image'
                                heic2any({
                                    // required: the HEIF blob file
                                    blob: file,
                                    // (optional) MIME type of the target file
                                    // it can be "image/jpeg", "image/png" or "image/gif"
                                    // defaults to "image/png"
                                    toType: "image/jpeg",
                                    // conversion quality
                                    // a number ranging from 0 to 1
                                    quality: 0.7
                                }).then((conversionResult) => {
                                    let reader = new FileReader();
                                    reader.onload = (e) => {
                                        item.url = e.target.result
                                    }
                                    reader.readAsDataURL(conversionResult);
                                    item.jpeg = conversionResult
                                })
                                .catch((e) => {
                                    console.log(e);
                                });
                            } else {
                                let reader = new FileReader();
                                reader.onload = (e) => {
                                    item.url = e.target.result
                                }
                                reader.readAsDataURL(file);
                            }
                        } else if (mediaType === 'video') {
                            this.videoPreview(file, item)
                        } else if (mediaType === 'audio') {
                            //item.url = '/assets/img/placeholders/audio-mini.svg'
                        }

                        this.images.push(item)
                    } else if (type === 'documents') {
                        this.documents.push({
                            id: key,
                            type_id: null,
                            file: file,
                            is_upload: true,
                            title: file.name,
                            link: null
                        })
                    }
                }
            })
        },
        acceptFile(file, type) {
            if (file.name.toLowerCase().match(/\.heic$/)) {
                return true
            }

            let accept_media = /^image\/*|^video\/*|^audio\/*/
            let accept_document = /^image\/*|^video\/*|^audio\/*|^application\/*/
            if (type === 'images') {
                if (!accept_media.test(file.type)) {
                    return false
                }
            } else {
                if (!accept_document.test(file.type)) {
                    return false
                }
            }
            return true
        },

        getClass(key) {
            if (key === 'title') {
                return 'w100'
            }
            if (key === 'body') {
                return 'w100'
            }
            if (['is_main', 'is_main_position'].includes(key)) {
                return 'w50'
            }
            return 'w33'
        },
        videoPreview (videoFile, file) {
            const canvas = document.createElement('canvas')
            const video = document.createElement('video')
            const context = canvas.getContext('2d')
            const url = URL.createObjectURL(videoFile)

            video.style.display = 'none'
            canvas.style.display = 'none'

            video.setAttribute('src', url)
            video.setAttribute('crossorigin', 'anonymous')

            document.body.appendChild(canvas)
            document.body.appendChild(video)

            if (!context) {
                return
            }

            video.currentTime = 1
            video.load()

            video.addEventListener('loadedmetadata', function () {
                canvas.width = video.videoWidth
                canvas.height = video.videoHeight
            })

            let image = null
            video.addEventListener('loadeddata', () => {
                context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight)
                canvas.toBlob((blob) => {
                    if (!blob) {
                        return
                    }
                    image = new File([blob], videoFile.name + '.png', {
                        type: 'image/png',
                    })
                    URL.revokeObjectURL(url)

                    let reader = new FileReader();
                    reader.onload = (e) => {
                        file.url = e.target.result
                        file.thumbnail = image
                    }
                    reader.readAsDataURL(image);

                    video.remove()
                    canvas.remove()
                }, 'image/png')
            })

        },
    }
}
</script>

<style scoped>

</style>
